import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Textarea,
  Text,
} from "@chakra-ui/react";
import { useField } from "formik";
import React, { InputHTMLAttributes } from "react";
import ReactInputMask from "react-input-mask";

type InputFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  name: string;
  textarea?: boolean;
  mask?: string;
  bgNone?: boolean;
  onChange?: () => void;
  rows?: number;
  noBorder?: boolean;
  noPadding?: boolean;
  onBlur?: () => void;
  autoComplete?: string;
  labelFontSize?: string;
};

const InputField: React.FC<InputFieldProps> = ({
  label,
  disabled,
  mask,
  textarea,
  bgNone = false,
  rows = 1,
  noBorder = false,
  width,
  noPadding = false,
  onBlur,
  autoComplete,
  labelFontSize,
  ...props
}) => {
  const [field, { error, touched }] = useField(props);

  if (mask && mask.length > 1) {
    return (
      <FormControl width={width} isInvalid={touched && error ? true : false} p={noPadding ? 0 : 1}>
        {label && <FormLabel pl={2} mb={0} mt={2}><em>{label}</em></FormLabel>}
        <Input
          bg={!bgNone ? 'white' : 'none'}
          color={!bgNone ? 'black': 'white'}
          as={ReactInputMask}
          mask={mask}
          disabled={disabled}
          type={props.type}
          {...field}
          isInvalid={touched && error ? true : false}
          borderRadius={noBorder ? 0 : '15px'}
          borderColor={'#6d6d6d'}
          placeholder={props.placeholder ? props.placeholder : label}
          onBlur={onBlur}
        />
        {error && <FormErrorMessage ml={2} mt={1}>{error}</FormErrorMessage>}
      </FormControl>
    );
  }
  if (textarea) {
    return (
      <FormControl isInvalid={touched && error ? true : false} p={noPadding ? 0 : 1}>
        {label && <FormLabel fontSize={labelFontSize} pl={3} mb={0} mt={2}><em>{label}</em></FormLabel>}
        <Textarea
          rows={rows}
          bg={!bgNone ? 'white' : 'none'}
          color={!bgNone ? 'black': 'white'}
          disabled={disabled}
          {...field}
          
          placeholder={props.placeholder ? props.placeholder : label}
          borderRadius={noBorder ? 0 : '15px'}
          borderColor={'#6d6d6d'}
        ></Textarea>
        {error && <FormErrorMessage ml={2} mt={1}>{error}</FormErrorMessage>}
      </FormControl>
    );
  }

  return (
    <FormControl width={width} isInvalid={touched && error ? true : false} p={noPadding ? 0 : 1}>
      {label && <FormLabel pl={2} mb={0} mt={2}><em>{label}</em></FormLabel>}
      <Input
        autoComplete={autoComplete}
        bg={!bgNone ? 'white' : 'none'}
        color={!bgNone ? 'black': 'white'}
        disabled={disabled}
        type={props.type}
        placeholder={props.placeholder ? props.placeholder : label}
        {...field}
        isInvalid={touched && error ? true : false}
        borderRadius={noBorder ? 0 : '15px'}
        borderColor={'#6d6d6d'}
        onBlur={onBlur}
      />
      {error && <FormErrorMessage ml={2} mt={1}>{error}</FormErrorMessage>}
    </FormControl>
  );
};


export default InputField;